import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LinePaperclipIcon from 'components/Luxkit/Icons/line/LinePaperclipIcon'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import useViewDocument from 'tripPlanner/hooks/useViewDocument'
import { TripDocument } from 'tripPlanner/types/documents'

const Root = styled(Group)`
  padding: ${rem(8)};
  background-color: ${({ theme }) => theme.palette.neutral.default.seven};
`

const Filename = styled(Caption)`
  flex: 1;
`

interface Props {
  document: TripDocument
}

function AttachedDocument({ document }: Props) {
  const showDocument = useViewDocument(document)

  return (
    <Root
      direction="horizontal"
      gap={12}
      verticalAlign="center"
      fullWidth
      onClick={showDocument}
    >
      <LinePaperclipIcon size="XS" colour="neutral-two" />
      <Filename variant="medium" colour="neutral-two" lineClamp={1}>
        {document.filename}
      </Filename>
    </Root>
  )
}

export default AttachedDocument
